var React = require('react');

function DownloadCircle (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M11.5 0c-6.341 0-11.5 5.159-11.5 11.5s5.159 11.5 11.5 11.5 11.5-5.159 11.5-11.5-5.159-11.5-11.5-11.5zm0 22c-5.79 0-10.5-4.71-10.5-10.5s4.71-10.5 10.5-10.5 10.5 4.71 10.5 10.5-4.71 10.5-10.5 10.5zM16.646 12.146l-4.646 4.647v-11.793c0-.276-.224-.5-.5-.5s-.5.224-.5.5v11.793l-4.647-4.646c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l5.499 5.5.163.108.192.038.191-.039.163-.108 5.499-5.5c.195-.195.195-.512 0-.707-.195-.195-.511-.195-.707 0z"})));
}

DownloadCircle.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = DownloadCircle;

DownloadCircle.default = DownloadCircle;
